// Only real future events may be labelled upcoming; API dates are ISO timestamps.
export function upcomingPublicEvents(events, now = Date.now()) {
  if (!Array.isArray(events)) throw new Error('Respuesta de eventos no válida');
  return events
    .filter(event => event && event.id && event.title && Number.isFinite(Date.parse(event.date)) && Date.parse(event.date) > now)
    .sort((a, b) => Date.parse(a.date) - Date.parse(b.date));
}
